export default __webpack_public_path__ + "static/media/check-purple.917dd028.svg";